"use client";
import MiniBannerSkeleton from "@packages/shared-components/skeleton/minibannerskeleton";
import React, { Suspense, useEffect } from "react";
import Image from "next/image";
import { ContentfulInspectorManager } from "../../../../lib/contentful-preview/ContentfulInspector";
import API_URL from "@packages/lib/server-actions/api-urls";
import optimizedSearch from "@packages/lib/server-actions/optimizedsearch";
import { useState } from "react";
import CourseTab from "../../searchBar/search-input-pods/coursetab";
import PgsSearch from "../../searchBar/search-pod/pgs-search";
import CoursetabSkeleton from "@packages/shared-components/skeleton/coursetabskeleton";
import { getClearingAjax } from "../../searchBar/search-utils/search-api";
import ClearingSearch from "../../searchBar/search-input-pods/ClearingSearch";
import { GA4EventAttrType } from "@packages/lib/types/datalayerGA";
import { usePathname } from "next/navigation";
import { GAConstants } from "@packages/shared-components/services/constants";
import AdviceSearchTab from "../../searchBar/search-input-pods/advice-search";
const MiniHeroBanner = ({
  data,
  iscontentPreview,
  contentModelName,
  searchpanel,
  pageName,
  isSubjectGuide = false,
  tagCloudElement,
}: any) => {
  const [course_data, setCourseData] = useState<any>({});
  const [uni_data, setUniData] = useState({});
  const [pgs_search_data, setPgssearchdata] = useState({});
  const [fetching, setFetching] = useState(true);
  const pathname = usePathname();
  const isScholarshipPage = pathname?.includes("scholarships") || false;
  const [searchFormHandle, setsearchFormHandle] = useState({
    activeTab: "tab1",
    isCourseType: false,
    isSubjectClicked: false,
    isLocationClicked: false,
    isAdviceClicked: false,
    isUniversityClicked: false,
    courseType: { qualUrl: "degree", qualCode: "M", qualDesc: "Undergraduate" },
    university: "",
    subject: {},
    location: {},
    advice: "",
  });

  const getCommonSearchBarGA = (): GA4EventAttrType => {
    let galogs = {
      event: GAConstants.track_event,
      //data_label: "clearing_subject_search",
      eventName: "search_event",
    };
    if (pageName) {
      galogs = { ...galogs };
    }

    return { ...galogs };
  };
  useEffect(() => {
    if (isSubjectGuide) {
      return;
    }
    const fetchData = async () => {
      const body: any = {
        affiliateId: 220703,
        actionType: "subject",
        keyword: "",
        qualCode: "",
        networkId: 2,
        pageName: "homepage",
      };

      const unibody: any = {
        affiliateId: 220703,
        actionType: "institution",
        keyword: "",
        qualCode: "",
        networkId: 2,
      };
      const queryParamsBody = new URLSearchParams(body).toString();
      const queryParamsunibody = new URLSearchParams(unibody).toString();
      try {
        const [bodyData, unibodyData] = await Promise.all([
          pageName === "clearingadvice"
            ? getClearingAjax()
            : optimizedSearch(
                process.env.NEXT_PUBLIC_BFF_API_DOMAIN + API_URL?.subjectAjax,
                "GET",
                null,
                queryParamsBody,
                null,
              ),
          optimizedSearch(
            process.env.NEXT_PUBLIC_BFF_API_DOMAIN + API_URL?.subjectAjax,
            "GET",
            null,
            queryParamsunibody,
            null,
          ),
        ]);

        setCourseData(bodyData);
        setUniData(unibodyData);
        setFetching(false);
      } catch (error) {
        setFetching(false);
        console.error("Error fetching data:", error);
      }
    };

    const fetchPgsData = async () => {
      const pgsbody: any = {
        affiliateId: process.env.AFFILATE_ID,
        actionType: "subject",
        keyword: "",
        qualCode: "",
        networkId: 2,
      };
      const queryParamspgsbody = new URLSearchParams(pgsbody).toString();

      try {
        const pgsdata = await optimizedSearch(
          API_URL?.subjectAjax,
          "GET",
          null,
          queryParamspgsbody,
          null,
        );

        setPgssearchdata(pgsdata);
        setFetching(false);
      } catch (error) {
        setFetching(false);
        console.error("Error fetching data:", error);
      }
    };

    if (
      !(Object.keys(uni_data)?.length > 0) &&
      !(Object.keys(course_data)?.length > 0) &&
      process.env.PROJECT == "Whatuni" &&
      searchpanel &&
      !isScholarshipPage
    ) {
      fetchData();
    } else {
      if (searchpanel && !isScholarshipPage) {
        fetchPgsData();
      } else {
        setFetching(false);
      }
    }
  }, []);
  return (
    <>
      {iscontentPreview && (
        <ContentfulInspectorManager
          fields={[
            {
              entryId: data.sys.id,
              fieldId: "title",
              targetSelector: "#mini_banner_title",
            },
            {
              entryId: data.sys.id,
              fieldId: "subTitle",
              targetSelector: "#mini_banner_description",
            },
            {
              entryId: data.sys.id,
              fieldId: "image",
              targetSelector: "#mini_banner_image",
            },
          ]}
        />
      )}
      {data && (
        <Suspense fallback={<MiniBannerSkeleton />}>
          <section className={data?.backgroundColor || "bg-blue-100"}>
            <div className="max-w-container mx-auto">
              {tagCloudElement && (
                <div className="px-[16px] md:px-[20px] xl:px-[0] pb-[16px]">
                  {tagCloudElement}
                </div>
              )}
              <div className="flex flex-col-reverse md:flex-row justify-between gap-[16px] p-[16px]  md:p-[24px_20px] lg:py-0 xl:px-0 min-h-[194px]">
                <div
                  className={`flex flex-col flex-grow gap-[16px] self-center ${
                    tagCloudElement ? "lg:pb-[48px]" : "lg:p-[64px_0_48px]"
                  }`}
                >
                  <div className="flex flex-col gap-[4px]">
                    <h1
                      className="text-heading-lg md:text-heading-xl"
                      id="mini_banner_title"
                    >
                      {data?.title}
                    </h1>
                    <p className="small" id="mini_banner_description">
                      {data?.subTitle}
                    </p>
                  </div>

                  {/* Search box */}
                  {searchpanel && !isSubjectGuide && (
                    <>
                      {process.env.PROJECT === "Whatuni" ? (
                        fetching ? (
                          <CoursetabSkeleton />
                        ) : pageName === "clearingadvice" &&
                          !isScholarshipPage ? (
                          <ClearingSearch
                            customGA={getCommonSearchBarGA()}
                            placeholder={"Enter subject"}
                            clearingCourseList={
                              course_data?.clearingSubjectList
                            }
                            locationList={course_data?.locationList}
                          />
                        ) : (
                          <CourseTab
                            placeholder={
                              isScholarshipPage
                                ? "Search subjects or universities"
                                : "Enter subject"
                            }
                            searchFormHandle={searchFormHandle}
                            setsearchFormHandle={setsearchFormHandle}
                            data={course_data}
                            showlocation={false}
                            isScholarshipSearch={isScholarshipPage}
                          />
                        )
                      ) : fetching ? (
                        <CoursetabSkeleton />
                      ) : (
                        <PgsSearch pgs_search_data={pgs_search_data} />
                      )}
                    </>
                  )}
                  {isSubjectGuide && <AdviceSearchTab />}
                </div>
                <div className="flex self-end justify-center w-full shrink-0 md:w-[219px]">
                  {data?.image?.imgUpload?.url && (
                    <Image
                      id="mini_banner_image"
                      src={data?.image?.imgUpload?.url}
                      width={295}
                      height={353}
                      priority
                      className="w-[130px] md:w-[219px] lg:w-[300px]"
                      fetchPriority="high"
                      alt={data?.image?.imgAltText}
                    />
                  )}
                </div>
              </div>
            </div>
          </section>
        </Suspense>
      )}
    </>
  );
};

export default MiniHeroBanner;
